import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { clearEmbedAccessToken } from '../../services/api';

/**
 * Mantém o embedToken no sessionStorage enquanto o usuário navega
 * entre lista e detalhe dentro de /embed/*.
 */
const EmbedLayout = () => {
  useEffect(() => {
    return () => {
      clearEmbedAccessToken();
    };
  }, []);

  return <Outlet />;
};

export default EmbedLayout;
